import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components';
import { createBrowserHistory } from 'history';
import './firebase';
const history = createBrowserHistory();
//import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <App history={history}/>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
